import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useGetListQuery } from "../../../features/api/Api";
import { isExists, params } from "../../../utils";

export const StatusHandler = () => {
  const { setFieldValue }: any = useFormikContext();

  const { data: statuses } = useGetListQuery<any>({
    resource: "fixity/customer/status",
    params: params,
  });

  const { data: conditions } = useGetListQuery<any>({
    resource: "fixity/customer/condition",
    params: params,
  });

  useEffect(() => {
    //Canlıya Böle çıkacak
    // if (isExists(statuses?.data)) {
    //   const newStatusId = statuses.data.find(
    //     (status: any) => status.name === "Yeni"
    //   )?.id;
    //   setFieldValue("customerDetail.statusId", newStatusId);
    // }

    //canlıya Çıkmayacak
    if (isExists(statuses?.data)) {
      const newStatusId = statuses.data.find(
        (status: any) => status.name === "Açık"
      )?.id;
      setFieldValue("customerDetail.statusId", newStatusId);
    }

    if (isExists(conditions?.data)) {
      const newConditionId = conditions.data.find(
        (condition: any) => condition.name === "Standart"
      )?.id;
      setFieldValue("customerDetail.conditionId", newConditionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statuses, conditions]);

  return null;
};

export const CustomerStatusHandler = () => {
  const { values, setFieldValue }: any = useFormikContext();

  const { data: statuses }: any = useGetListQuery({
    resource: "fixity/customer/status",
  });

  const { data: conditions } = useGetListQuery({
    resource: "fixity/customer/condition",
  });

  useEffect(() => {
    //Canlıya böle çıkacak
    // if (isExists(statuses?.data) && !isExists(values.customerDetail.statusId)) {
    //   const newStatusId = statuses.data.find(
    //     (status: any) => status.name === "Yeni"
    //   )?.id;
    // Canlıya böle çıkmayacak
    if (isExists(statuses?.data) && !isExists(values.customerDetail.statusId)) {
      const newStatusId = statuses.data.find(
        (status: any) => status.name === "Açık"
      )?.id;

      setFieldValue("customerDetail.statusId", newStatusId, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statuses]);

  useEffect(() => {
    if (
      isExists(conditions?.data) &&
      !isExists(values.customerDetail.conditionId)
    ) {
      const newConditionId = conditions?.data.find(
        (condition: any) => condition.name === "Standart"
      )?.id;

      setFieldValue("customerDetail.conditionId", newConditionId, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conditions]);

  return null;
};
